// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__-u+6z","copyright-text":"footer_copyright-text__MJ1M2"};